import React from 'react';
import PropTypes from 'prop-types';

import { Button, Typography } from '@mui/material';

import { Flex, BBDialog } from '../../components';

export const BBConfirmationDialog = ({
  children,
  isOpen,
  isLoading,
  isDisabled,
  title,
  subtitle,
  isDangerous,
  skipAutoOnClose,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onClose,
  onConfirm,
}) => {
  return (
    <BBDialog
      size="sm"
      title={title}
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      actions={
        <Flex.H sx={{ gap: '20px' }}>
          <Button
            color="secondary"
            variant="outlined"
            fullWidth
            sx={{ whiteSpace: 'nowrap' }}
            onClick={onClose}
          >
            {cancelText}
          </Button>

          <Button
            color={isDangerous ? 'error' : 'secondary'}
            variant="contained"
            disabled={isDisabled}
            fullWidth
            sx={{ whiteSpace: 'nowrap' }}
            onClick={() => {
              if (!skipAutoOnClose) {
                onClose();
              }
              onConfirm();
            }}
          >
            {confirmText}
          </Button>
        </Flex.H>
      }
    >
      <Flex.V sx={{ gap: '20px' }}>
        {subtitle && (
          <Typography sx={{ fontSize: '14px', color: '#000' }}>{subtitle}</Typography>
        )}
        {children}
      </Flex.V>
    </BBDialog>
  );
};

BBConfirmationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isDangerous: PropTypes.bool,
  skipAutoOnClose: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.any,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
